import { render } from "./SelectButtons.vue?vue&type=template&id=77dbbe1f"
import script from "./SelectButtons.vue?vue&type=script&lang=js"
export * from "./SelectButtons.vue?vue&type=script&lang=js"
script.render = render

export default script